import { useMemo } from 'react'
import { trpc } from '@klear/ui/lib/trpc'
import { deciderIdOf, type PeopleNames } from '@/app/document-review/review-people'
import type { DocumentReviewDetailOutput } from '@/app/document-review/use-document-review'

export function useReviewPeople(
  detail: Pick<DocumentReviewDetailOutput, 'reviewedBy' | 'step'> | undefined
): PeopleNames | null {
  const decider = detail === undefined ? null : deciderIdOf(detail)
  const ids = decider === null ? [] : [decider]
  const enabled = ids.length > 0
  const { data, isPending, isError } = trpc.user.list.useQuery({ ids, page: 1, limit: ids.length }, { enabled })
  const settled = !enabled || isError || !isPending
  return useMemo(() => {
    if (!settled) return null
    return new Map(
      (data?.items ?? []).flatMap((user) =>
        user.identity.kind === 'saved' && user.fullName !== '' ? [[user.identity.id, user.fullName] as const] : []
      )
    )
  }, [settled, data])
}
